import { unique } from 'radash';

import { CompanyProfile, Component, ComponentVisibility } from 'models';

import { useProducts } from 'hooks/use-products';
import { useProductsByIds } from 'hooks/use-products-by-ids';
import { ComponentListType } from 'services/ComponentService';

const useProductsByCompany = (company: CompanyProfile, { limit = 24, ...props }: ComponentListType = {}) => {
    const { products, isLoading, totalDocs } = useProducts({
        manufacturer: company.id,
        visibility: ComponentVisibility.PUBLIC,
        limit,
        ...props,
    });

    const { components: highlightedProducts } = useProductsByIds(company.highlightedComponents ?? []);

    const sortedHighlightedProducts = (company.highlightedComponents
        ?.map((id) => highlightedProducts.find((product) => product.id === id))
        .filter((product) => !!product) ?? []) as Component[];

    const otherProducts = products ?? [];

    return {
        highlightedProducts: sortedHighlightedProducts,
        otherProducts,
        products: unique([...sortedHighlightedProducts, ...otherProducts], ({ id }) => id),
        isLoading: isLoading,
        totalDocs,
    };
};

export { useProductsByCompany };
